import { createAction, props } from '@ngrx/store';

export const initAccessManagement = createAction('[AccessManagement Page] Init');

export const setSelectedTab = createAction(
  '[AccessManagement/UI] Set Selected Tab',
  props<{ tabIndex: number }>()
);

export const loadAccessManagementSuccess = createAction(
  '[AccessManagement/API] Load AccessManagement Success'
);

export const loadAccessManagementFailure = createAction(
  '[AccessManagement/API] Load AccessManagement Failure',
  props<{ error: Error | unknown }>()
);